import PlantA01 from '~/assets/img/plantas/A01.jpg'
import PlantA02 from '~/assets/img/plantas/A02.jpg'
import PlantA03 from '~/assets/img/plantas/A03.jpg'
import PlantA04 from '~/assets/img/plantas/A04.jpg'
import PlantA05 from '~/assets/img/plantas/A05.jpg'
import PlantA06 from '~/assets/img/plantas/A06.jpg'
import PlantA07 from '~/assets/img/plantas/A07.jpg'
import PlantA08 from '~/assets/img/plantas/A08.jpg'
import PlantB101 from '~/assets/img/plantas/B101.jpg'
import PlantB102 from '~/assets/img/plantas/B102.jpg'
import PlantB103 from '~/assets/img/plantas/B103.jpg'
import PlantB104 from '~/assets/img/plantas/B104.jpg'
import PlantB201 from '~/assets/img/plantas/B201.jpg'
import PlantB202 from '~/assets/img/plantas/B202.jpg'
import PlantB203 from '~/assets/img/plantas/B203.jpg'
import PlantB204 from '~/assets/img/plantas/B204.jpg'
import PlantC01 from '~/assets/img/plantas/C01.jpg'
import PlantC02 from '~/assets/img/plantas/C02.jpg'
import PlantC03 from '~/assets/img/plantas/C03.jpg'
import PlantC04 from '~/assets/img/plantas/C04.jpg'
// import commonAreas from '~/assets/img/plantas/areas-comuns.jpg'
// import underground from '~/assets/img/plantas/subsolo-garagens.jpg'
import ground from '~/assets/img/plantas/terreo.jpg'
import seaShore from '~/assets/img/plantas/beira-mar.jpg'

export default [
  PlantA01,
  PlantA02,
  PlantA03,
  PlantA04,
  PlantA05,
  PlantA06,
  PlantA07,
  PlantA08,
  PlantB101,
  PlantB102,
  PlantB103,
  PlantB104,
  PlantB201,
  PlantB202,
  PlantB203,
  PlantB204,
  PlantC01,
  PlantC02,
  PlantC03,
  PlantC04,
]

export const humanizedPlants = [ground, seaShore]
